export enum CompetitionType {
  Voice = 'Voice',
  MBB = 'MBB',
  All = 'All',
}

export enum CompetitionSaleType {
  New = 'New',
  Upgrade = 'Upgrade',
  All = 'All',
}

export enum CompetitionTypeText {
  Voice = 'Voice',
  MBB = 'MBB',
  All = 'Voice og MBB',
}

export enum CompetitionSaleTypeText {
  New = 'Nysalg',
  Upgrade = 'Oppgraderinger',
  All = 'Nysalg og oppgradering',
}

export enum CompetitionStatus {
  Upcoming = 'Upcoming',
  Active = 'Active',
  Ended = 'Ended',
}
